var React = require('react');

function Camera (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Group_43638","data-name":"Group 43638","transform":"translate(-3696 -195)"},[React.createElement("rect",{"id":"Rectangle_6959","data-name":"Rectangle 6959","width":"16","height":"11","rx":"2","transform":"translate(3696 195)","fill":"#fff","key":0}),React.createElement("path",{"id":"Polygon_1","data-name":"Polygon 1","d":"M3.628,1.549a1,1,0,0,1,1.743,0l2.79,4.96A1,1,0,0,1,7.29,8H1.71A1,1,0,0,1,.838,6.51Z","transform":"translate(3710 205) rotate(-90)","fill":"#fff","key":1})]));
}

Camera.defaultProps = {"width":"22","height":"11","viewBox":"0 0 22 11"};

module.exports = Camera;

Camera.default = Camera;
